import { z } from 'zod';

import { apiClient } from './client';

// backend отдаёт photos массивом ОБЪЕКТОВ ({index,path,url}); url === null, если
// presign недоступен (S3/MinIO down) -- деградация мягкая. Все поля optional/
// nullable, чтобы строгий .parse() не ронял листинг из-за одного битого фото.
export const ListingPhotoZ = z.object({
  index: z.number().int().optional(),
  path: z.string().optional(),
  url: z.string().nullable().optional(),
});
export type ListingPhoto = z.infer<typeof ListingPhotoZ>;

export const ListingZ = z.object({
  // listing == property; id ЕСТЬ property id. backend НЕ шлёт property_id/title
  // (раньше required -> Zod ронял каждый листинг).
  id: z.number().int(),
  property_id: z.number().int().optional(),
  title: z.string().optional(),
  description: z.string().nullable().optional(),
  city: z.string(),
  district: z.string().nullable().optional(),
  address: z.string(),
  type: z.string(),
  rooms: z.number().int().nullable().optional(),
  area_sqm: z.number().optional(),
  monthly_rate: z.number(),
  deposit_amount: z.number().nullable().optional(),
  photos: z.array(ListingPhotoZ).default([]),
  published_at: z.string().nullable().optional(),
});
export type Listing = z.infer<typeof ListingZ>;

const ListZ = z.object({
  data: z.array(ListingZ),
  meta: z
    .object({
      current_page: z.number().int(),
      last_page: z.number().int(),
      total: z.number().int(),
    })
    .partial()
    .optional(),
});
const OneZ = z.object({ data: ListingZ });

export interface ListingFilters {
  city?: string;
  type?: string;
  price_min?: number;
  price_max?: number;
  rooms?: number;
  page?: number;
}

export async function listListings(filters: ListingFilters = {}): Promise<{ data: Listing[] }> {
  const res = await apiClient.get('/listings', { params: filters });
  return { data: ListZ.parse(res.data).data };
}

export async function getListing(id: number): Promise<Listing> {
  const res = await apiClient.get(`/listings/${id}`);
  return OneZ.parse(res.data).data;
}

export async function applyToListing(id: number, payload: { message?: string }): Promise<void> {
  // Заявка = POST /applications { property_id, message } (роута /listings/{id}/apply нет).
  await apiClient.post('/applications', { property_id: id, message: payload.message });
}

export const listingsApi = { list: listListings, get: getListing, apply: applyToListing };
